import {combineReducers} from 'redux';
import {myAccountReducer} from '@ibibo/myaccount-reducer';

const reducerList = {
  myaccount: myAccountReducer
}

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;
